import { Truck } from "lucide-react";
import { LOCAL_PINCODE, LOCAL_DELIVERY_CHARGE, REMOTE_DELIVERY_CHARGE } from "@/utils/delivery";

export default function DeliveryInfo({ compact = false }) {
  if (compact) {
    return (
      <p className="font-outfit text-xs text-petal-muted leading-relaxed">
        ₹{LOCAL_DELIVERY_CHARGE} for pincode {LOCAL_PINCODE} · ₹{REMOTE_DELIVERY_CHARGE} outside local area
      </p>
    );
  }

  return (
    <div className="border border-petal-border p-4 bg-petal-beige-alt" data-testid="delivery-info">
      <div className="flex items-start gap-3">
        <Truck className="w-5 h-5 text-petal-gold shrink-0 mt-0.5" />
        <div>
          <p className="font-outfit text-xs uppercase tracking-widest text-petal-olive mb-2">Delivery Charges</p>
          <p className="font-outfit text-sm text-petal-olive-text">
            <span className="font-medium">₹{LOCAL_DELIVERY_CHARGE}</span>
            {" "}for pincode <span className="font-medium">{LOCAL_PINCODE}</span> (local area)
          </p>
          <p className="font-outfit text-sm text-petal-muted mt-1">
            <span className="font-medium text-petal-olive-text">₹{REMOTE_DELIVERY_CHARGE}</span>
            {" "}for deliveries outside pincode {LOCAL_PINCODE}
          </p>
        </div>
      </div>
    </div>
  );
}
